export enum OrderCargoOrderChangeApprovalStatusParamsApprovalStatus {
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
}

type OrderCargoOrderChangeApprovalStatusParams = {
  orderUuid: string;
  status: OrderCargoOrderChangeApprovalStatusParamsApprovalStatus;
};

export default OrderCargoOrderChangeApprovalStatusParams;
